import React, {useEffect} from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'

const Contact = () => {
    useEffect(()=> {
        AOS.init({duration: 1000})
    })
    return (
        <div name='contact' className='w-full h-full bg-gradient-to-b from-black to-gray-800 p-6 text-white'>
            <div className='flex flex-col p-6 justify-center max-w-screen-lg mx-auto h-screen'>
                <div className='pb-8'>
                    <p className='text-4xl font-bold inline border-b-4 border-gray-400'>Contact Me</p>
                    <p className='mt-6'>Submit the form below to get in touch with me</p>
                    <p className='mt-4'>Email :<span
              data-aos="fade-left"
              data-aos-easing="ease-in-sine"
              data-aos-duration="1000"
              className="animate-text bg-gradient-to-r from-orange-500 to-teal-500   via-purple-500 bg-clip-text text-transparent font-black"
            > arpitmishra482004@gmail.com</span> </p>
                    <p className='mt-2'>Contact :<span
              data-aos="fade-left"
              data-aos-easing="ease-in-sine"
              data-aos-duration="1000"
              className="animate-text bg-gradient-to-r from-orange-500 to-teal-500   via-purple-500 bg-clip-text text-transparent font-black"
            > +91 8601407992</span> </p>
                    <p className='mt-2'>Location :<span
              data-aos="fade-left"
              data-aos-easing="ease-in-sine"
              data-aos-duration="1000"
              className="animate-text bg-gradient-to-r from-orange-500 to-teal-500   via-purple-500 bg-clip-text text-transparent font-black"
            > 41F/8/5 Kharkauni Naini Prayagraj 211008</span> </p>
                
      
                </div>

                <div className='flex justify-center items-center'>
                    <form action="" method="POST" className='flex flex-col w-full md:w-1/2'>
                        <input data-aos="slide-up" data-aos-duration="500" required type="text" name='name' placeholder='Enter your name' className='p-2 m-2 bg-transparent border-2 rounded-md text-white focus:outline-none' />
                        <input data-aos="slide-up" data-aos-duration="700" required type="email" name='email' placeholder='Enter your Email' className='p-2 m-2 bg-transparent border-2 rounded-md text-white focus:outline-none' />
                        <textarea data-aos="fade-in" data-aos-duration="900" name="message" required rows="5" placeholder='Write your Query' className='p-2 bg-transparent border-2 m-2 rounded-md text-white focus:outline-none'></textarea>
                        <button data-aos="zoom-in" data-aos-duration="1000" type="submit" className='text-white bg-gradient-to-b from-cyan-500 to-blue-500 px-6 py-3 my-8 mx-auto flex items-center rounded-md hover:scale-110 duration-300'>Let's Talk</button>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default Contact